let CmsDatepicker = require('/Framework/assets/js/cms-datepicker');
class OwnerInput {
    static init($context = null) {
        let selector = "[data-input='owner']";
        let $inputs = $context ? $context.find(selector) : $(selector);

        $inputs.each(function (index, input) {
            if($(input).data('owner_instance')) return;
            $(input).data('owner_instance', new OwnerInput(input))
        });
    }

    ownerIdentityFields = [
        'Name', 'Surname', 'ILTUnumber', 'Birthdate', 'Email', 'Phone'
    ];
    searchTimeoutId = null


    constructor(input) {
        this.input = input
        this.lang = $('html').attr('lang')
        this.$input = $(input);
        this.baseUrl = this.input.dataset.baseUrl
        this.$ownerInput = this.$input.find('input');
        this.$ownerIdElement = this.$input.find('[data-owner-id]');
        this.$resetBtn = this.$input.find('[data-action="reset"]');
        this.$createBtn = this.$input.find('[data-action="create"]');
        this.$container = this.$input.closest('.form-group-container')
        this.$inputContainer = this.$input.closest('.form-group')
        this.$form = this.$input.closest('form')
        this.$progressBar = this.$input.find('[role="progressbar"]')
        this.$langFromInput = this.$form.find('[name$="[Language][from]"]')



        this.$container.on('change', function (){
            clearTimeout(this.searchTimeoutId)
            setTimeout(function (){
                this.onOwnerSearchFieldChange()
            }.bind(this), 1000)
        }.bind(this))

        this.$resetBtn.on('click', function (){
            this.$container.find(':input').attr('readonly', null).val('')
            this.$ownerIdElement.html('-')
            this.$resetBtn.addClass('d-none')
            this.$createBtn.addClass('d-none')
            this.removeMessages()
            this.enableIdentityInputs()
        }.bind(this))

        this.$createBtn.on('click', function (){
            this.createNewOwner();
        }.bind(this))

        if(this.$ownerInput.val()){
            this.disableIdentityInputs()
            this.onOwnerSearchFieldChange();
            this.$resetBtn.removeClass('d-none')
        }
    }

    showProgressBar(){
        this.$progressBar.removeClass('d-none')
    }
    hideProgressBar(){
        this.$progressBar.addClass('d-none')
    }

    getCodeFromInput(input){
        return input.name.slice(input.name.lastIndexOf('[')+1,-1);
    }
    getInputByCode(code){
        return this.$container.find(`[name$="[${code}]"]`);
    }
    disableIdentityInputs(){
        this.ownerIdentityFields.forEach( code => {
            let $input = this.getInputByCode(code)
            if($input.val()){
                if($input.data('input') === 'datepicker'){
                    $input[0]._flatpickr.destroy()
                    $input.data('datepicker_instance', null)
                }
                $input.attr('readonly', 'readonly')
            }else{
                $input.attr('readonly', null)
                if($input.data('input') === 'datepicker'){
                    new CmsDatepicker($input.data('options'), $input[0])
                }
            }
        })
    }
    enableIdentityInputs(){
        this.ownerIdentityFields.forEach( code => {
            let $input = this.getInputByCode(code)
            $input.attr('readonly', null)
            console.log($input.data('input'))
            if($input.data('input') === 'datepicker'){
                new CmsDatepicker($input.data('options'), $input[0])
            }
        })
    }

    getUserData(){
        let data = {};

        this.$container.find(':input').each(function (index, input) {
            let v = $(input).val()
            if(v){
                let f = this.getCodeFromInput(input)
                data[f] = v;
            }
        }.bind(this))
        return data;
    }

    onOwnerSearchFieldChange(){
        let data = this.getUserData();

        if(data.ILTUnumber){

            let query = {};
            let $serviceField = this.$form.find('[name="service"]');
            if($serviceField.length){
                query.service = $serviceField.val();
            }

            this.showProgressBar()

            $.post(`/api/${this.lang}/applications/find_owner?` + $.param(query), data).done(function (result) {
                if(result.status === 'ok'){
                    this.$ownerInput.val(result.owner.id)
                    this.$ownerIdElement.html(`#${result.owner.id}`)
                    this.$langFromInput.val(result.owner.lang).change()
                    for (const [key, value] of Object.entries(result.owner)) {
                        let $input = this.getInputByCode(key)
                        if(value){
                            $input.val(value)
                        }
                    }
                    this.disableIdentityInputs()
                    this.$resetBtn.removeClass('d-none')
                    this.$createBtn.addClass('d-none')
                    this.addMessage(result.message)

                    this.$input.removeClass('has-error')
                    this.$input.find('.invalid-feedback').html('')

                }else if(result.status === 'error'){
                    this.addMessage(result.error, 'danger')
                    this.$createBtn.removeClass('d-none')
                }

            }.bind(this)).always(function (){
                this.hideProgressBar()
            }.bind(this))
        }
    }

    addMessage(text, style='success'){
        this.removeMessages()
        this.$container
            .find(':input')
            .first()
            .closest('.form-group')
            .before(`<div class="col-12" data-owner-msg><div class="alert alert-${style}" role="alert"><i class="fa-solid fa-circle-exclamation fa-lg me-2"></i> ${text}</div></div>`)
    }
    removeMessages(){
        this.$container.find('[data-owner-msg]').remove();
    }

    createNewOwner(){
        let data = this.getUserData();

        const fancybox = new Fancybox([
            {
                src: this.baseUrl + "applications/add_owner?" + $.param({attributes : data} ),
                type: "iframe",
            },
        ], {
            on: {
                close: fancybox => {
                    console.log('aaa')
                    this.onOwnerSearchFieldChange()
                }
            }
        });
    }
}

OwnerInput.init()
export default OwnerInput;